export enum IdentifierType {
    ISIN = 'ISIN',
    SEDOL = 'SEDOL',
    TICKER = 'TICKER'
}